import { Type } from '@angular/core';
import { RolesExceptGuard } from './roles-except.guard';
import { RolesOnlyGuard } from './roles-only.guard';

export const GUARDS: Type<any>[] = [RolesExceptGuard, RolesOnlyGuard];
